import { CloseOutlined } from '@ant-design/icons';
import { CloseCircleIcon } from '@mm/icons';
import { useModalActions } from '@mm/state/modules/modalsState/actions';
import { colors } from '@mm/utils';
import classnames from 'classnames';
import React, { forwardRef } from 'react';
import Spinner from '../components/Spinner';
import {
  BasicModalProps,
  ModalHeaderProps,
  ModalProcessingBlinderProps,
} from './interfaces';
import './modal-helpers.pcss';

export type CloseModalProps = {
  closeModal: () => void;
};

type ModalBorderProps = {
  withBorder?: boolean;
};

type ModalStyleProps = {
  newStyle?: boolean;
};

const ModalHeader = (
  props: ModalHeaderProps & ModalBorderProps & ModalStyleProps,
) => {
  const {
    children,
    className,
    childrenContainerClassName,
    closeOverride,
    withBorder = true,
    closeIconColor,
    newStyle,
    ...rest
  } = props;
  const { closeModal } = useModalActions();
  const classList = classnames('modal-container__header', className, {
    'modal-container__header--border': withBorder,
    'modal-container__header--newStyle': newStyle,
  });
  const closeFunction = closeOverride || closeModal;

  return (
    <div className={classList} {...rest}>
      <div className={classnames(childrenContainerClassName)}>{children}</div>
      <div
        className="modal-container__header-close-button"
        onClick={() => closeFunction()}
      >
        {newStyle ? (
          <CloseOutlined
            color={closeIconColor || colors.gray}
            className="modal-container__header-close-button-icon"
          />
        ) : (
          <CloseCircleIcon color={closeIconColor} />
        )}
      </div>
    </div>
  );
};

const ModalBody = forwardRef<HTMLDivElement, BasicModalProps>(
  (props: BasicModalProps & { newStyle?: boolean }, ref) => {
    const { children, className, ...rest } = props;
    const classList = classnames('modal-container__body', className, {
      'modal-container__body--newStyle': props.newStyle,
    });

    return (
      <div className={classList} ref={ref} {...rest}>
        {children}
      </div>
    );
  },
);

const ModalFooter = (
  props: BasicModalProps & ModalBorderProps & ModalStyleProps,
) => {
  const { children, className, withBorder = true, ...rest } = props;
  const classList = classnames('modal-container__footer', className, {
    'modal-container__footer--border': withBorder,
  });

  return (
    <div className={classList} {...rest}>
      {children}
    </div>
  );
};

const ModalProcessingBlinder = (props: ModalProcessingBlinderProps) => {
  const { show, className } = props;
  const classList = classnames(
    'modal-container__processing-blinder',
    className,
  );

  if (!show) {
    return null;
  }

  return (
    <div className={classList}>
      <div className="modal-container__processing-blinder-background" />

      <Spinner
        show={true}
        size={50}
        position="relative"
        backgroundColor="transparent"
      />
    </div>
  );
};

export { ModalHeader, ModalBody, ModalFooter, ModalProcessingBlinder };
